// Sends the current cart to the sales team via WhatsApp.
// The phone number comes from Theme settings > WhatsApp (data-phone).

// Trade saves quantity edits after a debounce (ON_CHANGE_DEBOUNCE_TIMER in
// constants.js). Track the last edit so the message never uses a stale cart.
let lastCartEdit = 0;
document.addEventListener('change', function (event) {
  if (event.target.closest('cart-items, cart-drawer-items')) lastCartEdit = Date.now();
});

async function waitForCartIdle() {
  const debounce = (typeof ON_CHANGE_DEBOUNCE_TIMER === 'number' ? ON_CHANGE_DEBOUNCE_TIMER : 300) + 100;
  const deadline = Date.now() + 8000;
  while (Date.now() < deadline) {
    const pending = Date.now() - lastCartEdit < debounce;
    const saving = document.querySelector('.cart__items--disabled');
    if (!pending && !saving) return;
    await new Promise(resolve => setTimeout(resolve, 100));
  }
}

document.addEventListener('click', async function (event) {
  const button = event.target.closest('#bedon-whatsapp-cart, [data-bedon-whatsapp-cart]');
  // The cart page and the cart drawer can both load this script; handle each click once.
  if (!button || event.bedonWhatsappHandled) return;
  event.bedonWhatsappHandled = true;

  button.disabled = true;

  try {
    await waitForCartIdle();

    const response = await fetch(
      window.Shopify.routes.root + 'cart.js'
    );
    if (!response.ok) throw new Error('Cart error');

    const cart = await response.json();

    if (!cart.items.length) {
      alert('Tu carrito está vacío');
      return;
    }

    const money = cents =>
      new Intl.NumberFormat('es-EC', {
        style: 'currency',
        currency: cart.currency
      }).format(cents / 100);

    const lines = cart.items.map(item =>
      '• ' + item.product_title +
      (item.variant_title && item.variant_title !== 'Default Title'
        ? ' (' + item.variant_title + ')' : '') +
      (item.sku ? ' [' + item.sku + ']' : '') +
      ' x' + item.quantity +
      ' — ' + money(item.final_line_price)
    );

    const message =
      'Hola Comercial Bedón, quiero comprar:\n\n' +
      lines.join('\n') +
      '\n\nSubtotal: ' + money(cart.total_price);

    const phone = button.dataset.phone;

    window.location.href =
      'https://wa.me/' + phone +
      '?text=' + encodeURIComponent(message);

  } catch (error) {
    alert('No se pudo cargar el carrito. Intenta nuevamente.');
  } finally {
    button.disabled = false;
  }
});
